import { render } from "./ImpersonationOrdersHistory.vue?vue&type=template&id=78423149"
import script from "./ImpersonationOrdersHistory.vue?vue&type=script&lang=js"
export * from "./ImpersonationOrdersHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__